<section id="container-main" class="container-fluid ">
  <div class="row d-flex justify-content-center">
    <div class="col-12 col-sm-12 col-md-8 pr-5">
      <div class="row d-flex flex-row-reverse">
        <div class="col-12 col-sm-3 col-md-5 d-flex justify-content-center align-items-center">
          <img class="image" src="../../../assets/images/images/new-idea-bro.png" alt="">
        </div>
        <div class="col-12 col-sm-9 col-md-7">
          <h2 class="title">Actualízate</h2>
          <p>
            <b>VERSIÓN 316_20220131.</b>
            <br>
            Módulo Facturación:
            <br>
            Factura, Corte de Factura: Se configura el sistema con el fin de calcular el Auto-RteICA, según
            implementación de cada empresa.
            <br>
            Módulo Archivo:
            <br>
            Vehículos: Se crea opción de importación de información por archivo plano.
          </p>
          <div class="col d-flex justify-content-end">
            <button class="see-more"><a href="https://www.altos-soft.com/novedades">Ver más...</a></button>
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div class="col-11 col-sm-11 col-md-11">
          <hr>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-3 col-md-5  d-flex justify-content-center align-items-center">
          <img class="image" src="../../../assets/images/images/news-cuate.png" alt="">
        </div>
        <div class="col-12 col-sm-9 col-md-7">
          <h2 class="title">Noticias</h2>
          <p>
            En Altos Software estamos comprometidos con la calidad de nuestros servicios,
            es por ello que actualmente estamos en proceso de certificación en ISO27001.
          </p>
          <div class="col d-flex justify-content-start">
            <button class="see-more"><a href="https://www.instagram.com/altossoftware/">Ver más...</a></button>
          </div>
        </div>
      </div>
    </div>
    <div class=" col-11 col-sm-11 col-md-3 ">
      <div class="row d-flex justify-content-center  pt-sm-4 pt-md-0">
        <div class="notice">
          <div class="col-12 col-sm-12 col-md-12 ">
            <h2 id="title-notice" class="title">Atención</h2>
            <p class="text-notice text-break">
              <br>
              Para asesorías o solicitudes por
              favor enviar correo a : <b>as.altos.software&#64;gmail.com</b> o atención personalizada <br>
              (toma de requerimiento):<b> 304 559 3974.</b>
              <br>
              <br>Nuestros horarios de atención son:
              <br>Lunes a Jueves de 7:00 a.m. a 12:00 p.m. y de 1:00 p.m. a 5:15 p.m.
              <br>Viernes de 7:00 a.m. a 12:00 p.m. y de 1:00 p.m. a 5:00 p.m.
              <br>Sábados de 8:00 a.m. a 12:00 p.m.
            </p>
          </div>
          <div class="d-flex justify-content-center">
            <img class="image-notice" src="../../../assets/images/images/digital-personal.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</section>